export enum CommercialChannel {
  ONE_CLICK = 'ONC',
  OPEN_PLATFORM = 'OPT',
  CEMEX_GO = 'CXGO',
  SERVICE_CENTER = 'SC',
  MOBO = 'MOBO',
  MULTIPLE_ORDER = 'MO',
  SINGLE_ORDER = 'SO',
}
